'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/quickView'));
});
